module.exports = __webpack_public_path__ + "static/img/2-2-2.e9c6e4f8.jpg";